import type { AriaMobileDrawerMode } from '../models/aria-mobile-drawer.model';

/** `auto` → drawer quando `isMobile` (nel progetto: viewport ≤ 1200px). */
export function resolveAriaMobileDrawer(
  mode: AriaMobileDrawerMode,
  isMobile: boolean
): boolean {
  if (mode === 'always') {
    return true;
  }
  if (mode === 'never') {
    return false;
  }
  return isMobile;
}
